import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Spark from "@/assets/spark/spark";
import palettes from "@/contexts/theme-context/config/palleteConfig";

const COLORS = [palettes.dark.colors.theme.brandColor3, "white", "white"];
const SparksOverlay = ({ activeBandWhite = true }: { activeBandWhite?: boolean }) => {
  const [sparks, setSparks] = useState<{ id: number; x: number; y: number; size: number; color: string }[]>([]);


  useEffect(() => {
    const spawnSpark = () => {
      
      const x = Math.round(Math.random() * 100); // Snaps to multiples of 10%
      const y = Math.round(Math.random() * 100); // Snaps to multiples of 10%
      
      setSparks((prevSparks) => [
        ...prevSparks,
        {
          id: Date.now(),
          x,
          y,
          size: Math.random() * 1 + 1, // Random size between 0.75 and 1.25
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
        },
      ]);

      setTimeout(() => {
        setSparks((prevSparks) => prevSparks.slice(1));
      }, 1200);
    };

    const interval = setInterval(spawnSpark, Math.random() * 500 + 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <motion.div
        style={{
          position: "absolute",
          width: "150%", // Makes the gradient wider for a smooth transition
          height: "100%",
          zIndex: 105,
          top:0,
          mixBlendMode: "overlay",
          background: activeBandWhite ? `linear-gradient(-120deg,
            transparent 30%,
            rgba(255, 255, 255, 0.9) 50%,
            transparent 70%)` : 'transparent',
          transform: "rotate(0deg)",
        }}
        animate={{
          x: ["-100%", "100%"], // Moves from left to right
        }}
        transition={{
          duration: 4,
          ease: "easeInOut",
          repeat: Infinity,
          repeatDelay: 3
        }}
      />
      <motion.div
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: 100,
          top:0,
          overflow: "hidden",
        }}
      >

        <AnimatePresence>
          {sparks.map((spark) => (
            <motion.div
              key={spark.id}
              initial={{ opacity: 0, scale: spark.size * 0.8 }}
              animate={{ opacity: 1, scale: spark.size }}
              exit={{ opacity: 0, scale: spark.size * 1.2 }}
              transition={{ duration: 1 }}
              style={{
                position: "absolute",
                left: `${spark.x}%`,
                top: `${spark.y}%`,
                filter: `drop-shadow(0 0 2px ${spark.color})`,
              }}
            >
              <Spark color={spark.color} />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
    </>
  );
};

export default SparksOverlay;